import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { MarketsCard } from "Market/Widgets/MarketsCard";
import { PageContainer } from "Shared/Components/Container";
import { Typography } from "@mui/material";
import type { FC } from "react";
import { useParams } from "react-router";
import type { MarketEditTabs } from "../Components/Tabs/Hooks/useMarketEditTabs";

const marketResource = Resources.base.market.shared;

type MarketPageProps = {
	currentTab?: MarketEditTabs;
};

export const MarketsPage: FC<MarketPageProps> = ({ currentTab }) => {
	const { t } = useResource();
	const { urlPath: paramsUrlPath } = useParams();

	return (
		<PageContainer
			title={t(marketResource.title)}
			description={t(marketResource.description)}
		>
			<Typography mb={2} variant="h2">
				{t(marketResource.title)}
			</Typography>
			<MarketsCard urlPath={paramsUrlPath} currentTab={currentTab} />
		</PageContainer>
	);
};
